import { Icon, IconsEnum } from 'components/Icons';
import { Button } from 'components/button/Button';
import styles from './MieScommesseTableRow.module.scss';
import { ButtonField } from './buttonField/ButtonField';
import { StateField } from './stateField/StateField';

export type FieldProps = {
  label?: string;
  value?: string | number | null;
  className?: string;
  classNameData?: string;
  internalClassName?: string;
  event?: {
    win: number;
    live: number;
    programmed: number;
    lose: number;
  };
  isInColumn?: boolean;
  noMargin?: boolean;
  type?: string;
};

export type TableFieldProps = {
  component: React.ComponentType<any> | null;
  props: any;
};

export type MieScommesseTableRowProps = {
  columns: TableFieldProps[];
  onClick?: () => void;
  noArrowButton?: boolean;

  className?: string;
  internalClassName?: string;
  isGridFiveColumns?: boolean;
};

export const MieScommesseTableRow = ({
  columns,
  onClick,
  noArrowButton,

  className,
  internalClassName,
  isGridFiveColumns,
}: MieScommesseTableRowProps) => {
  const stateField = columns.find((column) => column.component === StateField);
  const buttonField = columns.find((column) => column.component === ButtonField);

  const createField = () => {
    return columns.map((column, i) => {
      return column.component === StateField || !column.component ? null : (
        <column.component {...column.props} key={i} />
      );
    });
  };

  const createState = () => {
    return !stateField || !stateField.component || buttonField ? null : <stateField.component {...stateField.props} />;
  };

  return (
    <div
      className={`${styles.container} ${className ? className : ''} ${
        internalClassName ? styles[internalClassName] : ''
      }`}
    >
      <div className={styles.flexContainer}>
        <div className={`${styles.grid} ${isGridFiveColumns ? styles.gridFive : ''}`}>
          {createField()}
          {createState()}
        </div>

        {!noArrowButton && (
          <Button className={styles.iconContainer} onClick={onClick}>
            <Icon iconId={IconsEnum.CHEVRON_RIGHT} className={styles.arrowIcon} color="var(--color-primary)" />
          </Button>
        )}
      </div>
    </div>
  );
};
